var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmTae = function SvgBmTae(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BM_TAE",
    transform: "translate(-374 -125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 18,
    height: 18,
    transform: "translate(374 125)",
    fill: "#fff",
    opacity: 0.004
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(372 121.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M12.385,6.5a5.764,5.764,0,0,1,2.955.789A5.829,5.829,0,0,1,17.481,9.43a5.93,5.93,0,0,1,0,5.91,5.829,5.829,0,0,1-2.141,2.141,5.93,5.93,0,0,1-5.91,0,5.829,5.829,0,0,1-2.141-2.141,5.93,5.93,0,0,1,0-5.91A5.829,5.829,0,0,1,9.43,7.289,5.764,5.764,0,0,1,12.385,6.5Zm.656,6.357.341-3.363a.383.383,0,0,0-.1-.328.412.412,0,0,0-.315-.145H11.807a.412.412,0,0,0-.315.145.383.383,0,0,0-.1.328l.341,3.363a.34.34,0,0,0,.118.263.406.406,0,0,0,.276.1h.526a.406.406,0,0,0,.276-.1A.34.34,0,0,0,13.041,12.857Zm-.656,2.89a.852.852,0,1,0-.591-.25A.807.807,0,0,0,12.385,15.747Z",
    transform: "translate(-1.385 -0.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(2 5.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(13.846 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M22.692,18.818a.692.692,0,0,1-.462-1.207,7.589,7.589,0,0,0,0-11.33.692.692,0,0,1,.925-1.03,8.973,8.973,0,0,1,0,13.391A.688.688,0,0,1,22.692,18.818Z",
    transform: "translate(-22 -5.074)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M5.462,18.818A.688.688,0,0,1,5,18.641,8.973,8.973,0,0,1,5,5.25a.692.692,0,0,1,.925,1.03,7.589,7.589,0,0,0,0,11.33.692.692,0,0,1-.462,1.207Z",
    transform: "translate(-2 -5.073)",
    fill: "#fff"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmTae, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_TAE.f90e6179.svg";
export { ForwardRef as ReactComponent };